import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

const categoryAndGroupAPI = {

    createCategory(name: string, teacher_uuid?: string, isadmin?: boolean) {
        const payload: { name: string; teacher_uuid?: string; isadmin?: true } = { name, teacher_uuid };
        if (isadmin === true) {
            payload.isadmin = true;
        }

        return apiServices
            .post(`/api/category`, payload, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error createCategory:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getAllCategories() {
        return apiServices
            .get(`/api/category`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getAllCategories:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getCategoriesByTeacherUuid(teacher_uuid: string) {
        return apiServices
            .get(`/api/category/teacher/${teacher_uuid}`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getCategoriesByTeacherUuid:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    updateCategory(id: number | string, name: string) {
        return apiServices
            .put(
                `/api/category/${id}`,
                { name },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error updateCategory:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    softDeleteCategory(id: number | string) {
        return apiServices
            .patch(
                `/api/category/${id}/soft-delete`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                    },
                }
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error softDeleteCategory:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    createGroup(name: string, teacher_uuid?: string, isadmin?: boolean) {
        const payload: { name: string; teacher_uuid?: string; isadmin?: true } = { name, teacher_uuid };
        if (isadmin === true) {
            payload.isadmin = true;
        }

        return apiServices
            .post(`/api/group`, payload, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error createGroup:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getAllGroups() {
        return apiServices
            .get(`/api/group`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getAllGroups:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getGroupsByTeacherUuid(teacher_uuid: string) {
        return apiServices
            .get(`/api/group/teacher/${teacher_uuid}`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getGroupsByTeacherUuid:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    updateGroup(id: number | string, name: string) {
        return apiServices
            .put(
                `/api/group/${id}`,
                { name },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error updateGroup:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    softDeleteGroup(id: number | string) {
        return apiServices
            .patch(
                `/api/group/${id}/soft-delete`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                    },
                }
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error softDeleteGroup:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

}

export default categoryAndGroupAPI;